<template>
  <div id="sidebar-full">
    <div
      v-touch:swipe.left="closeSidebar"
      :class="isActive()"
      @click="closeSidebar()"
      class="sidebar-bg"
    ></div>
    <div v-touch:swipe.left="closeSidebar" :class="isActive()" id="sidebar">
      <fai @click="closeSidebar()" class="close-sidebar" icon="angle-left"></fai>
      <ul class="menu" v-if="menus.header">
        <li v-for="(menuItem, i) in menus.header.items" :key="i">
          <div v-if="menuItem.component === 'menuGroupItem'" class="submenu">
            <a
              :href="setHref(menuItem.link)"
              @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank, menuItem.anchor)"
              class="menu-item"
              v-html="menuItem.title"
            ></a>
            <ul>
              <li v-for="menuItem in menuItem.items" :key="menuItem.uid">
                <a
                  class="menu-item"
                  @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank, menuItem.anchor)"
                  href="#"
                  v-html="menuItem.title"
                ></a>
              </li>
            </ul>
          </div>
          <a
            class="menu-item"
            v-else
            @click.prevent="getStoryblokLink(menuItem.link, menuItem.blank, menuItem.anchor)"
            href="#"
            v-html="menuItem.title"
          ></a>
        </li>
      </ul>
       <div class="checkout-btn-mobile">
        <checkout-btn></checkout-btn>
      </div>
      <switch-lang></switch-lang>
    </div>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  computed: {
    sidebarStatus() {
      return this.$store.getters.sidebarStatus;
    },
    menus() {
      return this.$store.getters.menus;
    }
  },
  methods: {
    isActive() {
      return this.sidebarStatus ? "active" : "";
    },
    closeSidebar() {
      this.$store.commit("SET_SIDEBAR_STATUS", false);
    }
  }
};
</script>

<style lang="scss">
#sidebar {
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 220px;
  transform: translateX(-300px);
  background: $primary;
  transition: transform 0.4s;
  z-index: 2;
  &.active {
    transform: translateX(0px);
    z-index: 333333;
    overflow: scroll;
  }
  .close-sidebar {
    font-size: 150%;
    position: absolute;
    left: 10px;
    top: 10px;
    color: #fff;
    cursor: pointer;
  }
}
.sidebar-bg {
  &.active {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3333;
  }
}

#sidebar-full {
  .menu {
    padding: 50px 15px;
    li {
      .menu-item {
        color: #fff;
        text-decoration: none;
        font-size: 19px;
        padding: 10px 0px;
        display: block;
        font-weight: bold;
      }
    }
    > li {
      .submenu {
        span {
        }
        > ul {
          > li {
            padding-left: 20px;
            a {
              padding: 7px 0px;
              font-size: 15px;
              font-weight: initial;
            }
          }
        }
      }
      a {
      }
    }
  }
}

#sidebar-full {
  .switch-lang {
    background-color: transparent !important;
    .current-lang {
      display: none;
    }
    > ul {
      display: block;
      position: relative;
      background-color: transparent !important;
      top: inherit;
      width: 100%;
      > li {
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
}
.checkout-btn-mobile {
  display:flex;
  align-items: center;
  justify-content: center;
  position:relative;
  z-index:300;
}
</style>
